<template>
  <div>
    <!-- TODO: refactor markup Header Component-->
    <b-navbar  type="light" fixed="top" toggleable="lg" class="navbar-default py-0">
      <b-container>
        <b-navbar-brand href="#">
          <img src="@/assets/images/logos/logo.png" alt="logo"/>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <mainMenu></mainMenu>
          <Languages />
          <b-navbar-nav class="ml-auto mt-3 mt-sm-0">
            <userData></userData>
            <secondaryMenu></secondaryMenu>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

  </div>
</template>

<script>
import mainMenu from './main_menu'
import Languages from '@/shared/components/languages'
import secondaryMenu from './secondary_menu'
import userData from './user_data'

export default {
  name: 'privateHeader',
  components: { mainMenu, secondaryMenu, userData, Languages }
}
</script>
